import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, TextField, Button, List, ListItem, ListItemText, Divider, } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAssetDisposalLogs, postDisposalApproval } from '../../ReduxStore/AssetDisposalSlice';
import AssetTable from '../AssetTransfer/AssetTable';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { getSafeHttpUrl } from '../../utils/safeUrl';



const header = [
    "Asset Code / No.",
    "Asset Description",
    "Asset Type",
    "PO No.",
    "PO Line Item No.",
    "PO Line Item Description",
    "GST%",
    "SGST%",
    "IGST%",
    "HSN Code",
    "Remark"
];
const header2 = [
    "Asset Code / No.",
    "Asset Description",
    "Asset Type",
    "PO No.",
    "PO Line Item No.",
    "PO Line Item Description",
    // "EPCG Obligations",
    "EPCG Obligations",
    "Remark"
];

const header3 = [
    "Asset Code / No.",
    "Asset Description",
    "Asset Type",
    "PO No.",
    "PO Line Item No.",
    "PO Line Item Description",
    "Sales Order No",
    "UTR NO",
    "UTR Date",
    "Customer",
    "File URL"
];



const AssetDisposalDetail = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Asset Disposal Table', href: '/asset-disposal-table' },
    ];
    // const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const disposal_id = pathname[2];

    const [loading, setLoading] = useState(true);
    // const [postLoading, setPostLoading] = useState(false);
    const [assetDisposals, setAssetDisposals] = useState({});
    const [idtStatus, setIdtStatus] = useState("Not Done");
    const [importStatus, setImportStatus] = useState("Not Done");
    const [SCMStatus, setSCMStatus] = useState("Not Done");
    // const [DOA, setDOA] = useState([]);
    const [reviewComments, setReviewComments] = useState([]);
    const [header2Data, setHeader2Data] = useState([]); // Prefilled data for second table
    const [IDTRowsData, setIDTRowsData] = useState([]);
    const [ImportRowsData, setImportRowsData] = useState([]);
    const [FinalSubRowData, setFinalSubRowsData] = useState([]);
    const [IDTFile, setIDTFile] = useState({
        filename: "",
        file: null
    });
    const [ImportFile, setImportFile] = useState({
        filename: "",
        file: null
    });
    // const [IDTRemark, setIDTRemark] = useState("");
    // const [ImportRemark, setImportRemark] = useState("");
    const [loadingStates, setLoadingStates] = useState([]);

    const handleIDTFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setIDTFile({
                filename: file.name,  // Set the file name
                file: file            // Store the actual file object
            });
        }
    };
    const handleImportFile = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImportFile({
                filename: file.name,  // Set the file name
                file: file            // Store the actual file object
            });
        }
    };

    const handleIDTRowChange = (rows) => {
        setIDTRowsData(rows);
    };

    const handleImportRowChange = (rows) => {
        setImportRowsData(rows);
    };

    const handleFinalSubmissionChange = (rows) => {
        setFinalSubRowsData(rows)
    };

    const handleReviewCommentChange = (index, value) => {
        const updatedComments = [...reviewComments];
        updatedComments[index] = value;
        setReviewComments(updatedComments);
    };

    // const getOtherDetailsPayload = (department,levelname) => {
    //     if (department === "IDT") {
    //         return IDTRowsData.map(row => ({
    //             asset_no: row["Asset Code / No."],
    //             "GST %": row["GST%"],
    //             "IGST %": row["IGST%"],
    //             "SGST %": row["SGST%"],
    //             "HSN Code": row["HSN Code"],
    //             "Remark": row["Remark"]
    //         }));
    //     } else if (department === "Import") {
    //         return ImportRowsData.map(row => ({
    //             asset_no: row["Asset Code / No."],
    //             "EPCG Obligations": row['EPCG Obligations'],
    //             "Remark": row["Remark"] || "" // Ensure a default value if Remark is not provided
    //         }));
    //     } else if (department === "SCM" && levelname === "L5") {
    //         return FinalSubRowData.map(row => ({
    //             asset_no: row["Asset No."],
    //             sales_order_no: row["Sales Order No"],
    //             Utr_no: row["UTR NO"],
    //             Utr_Date: row["UTR Date"],
    //             customer: row["Customer"],
    //         }))
    //     }
    // };
    const getOtherDetailsPayload = (department, levelname) => {
        if (department === "IDT") {
            return {
                comments: IDTRowsData.map(row => ({
                    asset_no: row["Asset Code / No."],
                    "GST %": row["GST%"],
                    "IGST %": row["IGST%"],
                    "SGST %": row["SGST%"],
                    "HSN Code": row["HSN Code"],
                    "Remark": row["Remark"]
                }))
            };
        } else if (department === "Import") {
            return {
                comments: ImportRowsData.map(row => ({
                    asset_no: row["Asset Code / No."],
                    "EPCG Obligations": row['EPCG Obligations'],
                    "Remark": row["Remark"] || "" // Default value for Remark if not provided
                }))
            };
        } else if (department === "SCM" && levelname === "L5") {
            return {
                comments: FinalSubRowData.map(row => ({
                    asset_no: row["Asset No."],
                    sales_order_no: row["Sales Order No"],
                    Utr_no: row["UTR NO"],
                    Utr_Date: row["UTR Date"],
                    customer: row["Customer"]
                }))
            };
        }
    };

    const handleAction = async (index, item, action) => {

        const newLoadingStates = [...loadingStates];
        newLoadingStates[index] = true; // Set loading state for the specific index
        setLoadingStates(newLoadingStates);

        const payload = {
            disposal_logs_id: disposal_id,
            level_name: item.levelname,
            level_sequence: item.level_sequence,
            comment: reviewComments[index],
            status: action,
            // other_details: {
            //     comments: item.department === "IDT"
            //         ? IDTRowsData.map(row => ({
            //             asset_no: row["Asset Code / No."],
            //             "GST %": row["GST%"],
            //             "IGST %": row["IGST%"],
            //             "SGST %": row["SGST%"],
            //             "HSN Code": row["HSN Code"],
            //             "Remark": row["Remark"]
            //         }))
            //         : item.department === "SCM"
            //             ? FinalSubRowData.map(row => ({
            //                 asset_no: row["Asset No."],
            //                 sales_order_no: row["Sales Order No"],
            //                 Utr_no: row["UTR NO"],
            //                 Utr_Date: row["UTR Date"],
            //                 customer: row["Customer"],
            //             }))
            //             : ImportRowsData.map(row => ({
            //                 asset_no: row["Asset Code / No."],
            //                 "EPCG Obligations": row['EPCG Obligations'],
            //                 "Remark": row["Remark"] || "" // Ensure a default value if Remark is not provided
            //             }))
            // }
            other_details: getOtherDetailsPayload(item.department, item.levelname)
        };

        console.log("check Payload", payload)
        try {
            const action = dispatch(postDisposalApproval(payload));
            const res = await action.unwrap();
            console.log("res", res)
            if (res.StatusCode === 201) {
                getAssetDisposalDetails();
                toast.success("Success");
                // Optionally navigate after a delay
                // setTimeout(() => {
                //     navigate("/breakdown-management");
                // }, 2000);
            } else if (res.StatusCode === 205) {
                toast.info("Approval not allowed. Previous approvals pending");
            } else {
                toast.error("An error occurred. Please try again.");
            }

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        } finally {
            setLoadingStates(prevStates => {
                const newLoadingStates = [...prevStates];
                newLoadingStates[index] = false;  // Reset loading state for this button
                return newLoadingStates;
            });
        }
    }


    const getAssetDisposalDetails = async () => {
        try {
            const action = dispatch(getAssetDisposalLogs(`?id=${disposal_id}`));
            const res = await action.unwrap();
            console.log("RES Of Disposal", res.result.doa)
            if (res.result) {
                setAssetDisposals(res.result)

                if (res.result.approvals.length > 0) {
                    // Set the status for IDT and Import
                    const idtApproval = res.result.approvals.find(approval => approval.level_name === "IDT");
                    const importApproval = res.result.approvals.find(approval => approval.level_name === "L4"); // Assuming "L4" corresponds to Import
                    const finalApproval = res.result.approvals.find(approval => approval.level_name === "L5");

                    setIdtStatus(idtApproval ? idtApproval.status : "Not Approved");
                    setImportStatus(importApproval ? importApproval.status : "Not Approved");
                    setSCMStatus(finalApproval ? finalApproval.status : "Not Approved")
                }
            };
        } catch (error) {
            toast.error(error.message || "No Logs Found!");
        }
    }

    // const getDOAs = async () => {
    //     try {
    //         const action = dispatch(getDisposalDOA());
    //         const res = await action.unwrap();
    //         console.log("DOA res", res.result)
    //         if (res.result) {
    //             setDOA(res.result)
    //         };
    //     } catch (error) {
    //         console.error("Error in okHandler:", error);
    //         toast.error(error.message || "No Logs Found!");
    //     }
    // }


    useEffect(() => {
        const fetchData = async () => {
            await getAssetDisposalDetails();
            // await getDOAs();
            setLoading(false);
        };
        fetchData();
    }, [])

    // useEffect(() => {
    //     if (assetDisposals?.asset_details?.length > 0) {
    //         // Mapping the asset details to the required header format
    //         const mappedHeader2Data = assetDisposals.asset_details.map(row => ({
    //             "Asset Code / No.": row["asset_no"],
    //             "Asset Description": row["description"],
    //             "Asset Type": row.other_details["Asset Type"], // Accessing nested data
    //             "PO No.": row.other_details["PO No"], // Accessing nested data
    //             "PO Line Item No.": row.other_details["PO Line Item No"], // Accessing nested data
    //             "PO Line Item Description": row.other_details["PO Line Item Description"] // Accessing nested data
    //         }));

    //         // Setting the mapped data to state
    //         setHeader2Data(mappedHeader2Data);

    //     }
    // }, [assetDisposals])

    // useEffect(() => {
    //     if (assetDisposals?.asset_details?.length > 0) {
    //         // Mapping the asset details to the required header format
    //         const mappedHeader2Data = assetDisposals.asset_details.map(row => {
    //             const approvalForAsset = assetDisposals.approvals.find(approval =>
    //                 approval.other_details?.comments?.some(comment => comment.asset_no === row.asset_no)
    //             );

    //             const commentsForAsset = approvalForAsset
    //                 ? approvalForAsset.other_details.comments.find(comment => comment.asset_no === row.asset_no)
    //                 : null;

    //             return {
    //                 "Asset Code / No.": row["asset_no"],
    //                 "Asset Description": row["description"],
    //                 "Asset Type": row.other_details["Asset Type"],
    //                 "PO No.": row.other_details["PO No"],
    //                 "PO Line Item No.": row.other_details["PO Line Item No"],
    //                 "PO Line Item Description": row.other_details["PO Line Item Description"],
    //                 "GST%": commentsForAsset ? commentsForAsset["GST %"] : '', // Mapping GST % from comments
    //                 "IGST%": commentsForAsset ? commentsForAsset["IGST %"] : '', // Mapping IGST % from comments
    //                 "SGST%": commentsForAsset ? commentsForAsset["SGST %"] : '', // Mapping SGST % from comments
    //                 "HSN Code": commentsForAsset ? commentsForAsset["HSN Code"] : '', // Mapping HSN Code from comments
    //                 "Remark": commentsForAsset ? commentsForAsset["Remark"] : '', // Mapping Remark from comments
    //                 "EPCG Obligations": commentsForAsset ? commentsForAsset["EPCG Obligations"] : '',
    //             };
    //         });

    //         // Setting the mapped data to state
    //         setHeader2Data(mappedHeader2Data);
    //         // setIDTRowsData(mappedHeader2Data);
    //     }
    // }, [assetDisposals]);

    useEffect(() => {
        if (assetDisposals?.asset_details?.length > 0) {
            // Mapping asset details to the required header format
            const mappedHeader2Data = assetDisposals.asset_details.map((row) => {

                const modifiedAssetNo = row.asset_no.substring(3);

                // Find the matching comments based on asset_no
                const comments = assetDisposals.approvals.flatMap(approval =>
                    approval.other_details?.comments?.filter(comment => comment.asset_no === row.asset_no) || []
                );
                // Extract first and second comment (if available)
                const firstComment = comments[0] || {};
                const secondComment = comments[1] || {};

                // Find the last comment specifically from the approval with level_sequence 10
                const lastApproval = assetDisposals.approvals.find(approval => approval.level_sequence === 10);
                const lastComment = lastApproval?.other_details?.comments?.[0] || {};

                // Find the attached file that matches the asset description
                const attachedFile = assetDisposals.attached_files.find(file =>
                    file.description.includes(row.asset_no)
                );

                // Extract the URL if it exists
                const fileUrl = attachedFile ? attachedFile.url : '';
                console.log("check URL:", fileUrl)

                // Return the required format including the comments
                return {
                    // "Asset Code / No.": row["asset_no"],
                    "Asset Code / No.": modifiedAssetNo, // Use the modified asset_no here
                    "Asset Description": row["description"],
                    "Asset Type": row.other_details["Asset Type"],
                    "PO No.": row.other_details["PO No"],
                    "PO Line Item No.": row.other_details["PO Line Item No"],
                    "PO Line Item Description": row.other_details["PO Line Item Description"],
                    // Map the first comment (if available) to the corresponding keys
                    "GST%": firstComment["GST %"] || "",
                    "IGST%": firstComment["IGST %"] || "",
                    "SGST%": firstComment["SGST %"] || "",
                    "HSN Code": firstComment["HSN Code"] || "",
                    "Remark": firstComment["Remark"] || "",
                    // Map the second comment (if available) to the corresponding keys
                    "EPCG Obligations": secondComment["EPCG Obligations"] || "",
                    // "Remark": secondComment["Remark"] || "No Remark"
                    "Sales Order No": lastComment['sales_order_no'] || "",
                    "UTR NO": lastComment['Utr_no'] || "",
                    "UTR Date": lastComment['Utr_Date'] || "",
                    "Customer": lastComment['customer'] || "",
                    // Include the file URL
                    "File": fileUrl || "No file attached"
                };
            });

            // Setting the mapped data to state
            setHeader2Data(mappedHeader2Data);
        }
    }, [assetDisposals]);


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Asset Disposal Details
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Asset Disposal Details" />
                </Box>
                {/* <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Raiser Name

                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Raiser Department
                            <h4>{assetDisposals.raiser_dept}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            Disposal Date
                            <h4>{new Date(assetDisposals.raiser_date).toLocaleString()}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Reason
                            <h4>{assetDisposals.reason}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Status
                            <h4>{assetDisposals.status}</h4>
                        </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Current Vendor
                            <h4>{assetDisposals.old_vendor_no}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            New vendor
                            <h4>{assetDisposals.new_vendor_no}</h4>
                        </Grid>
                    </Grid>


                </Box> */}
                {/* <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            Asset Details
                            {assetDisposals && assetDisposals.asset_details.length > 0 && (
                                <List>
                                    {assetDisposals.asset_details.map((asset, index) => {
                                        return (
                                            <div key={index}>
                                                <ListItem>
                                                    <ListItemText
                                                        primary={`${asset.asset_no} | ${asset.description}`}
                                                    />
                                                </ListItem>
                                                {index < assetDisposals.asset_details.length - 1 && <Divider />}
                                            </div>
                                        );
                                    })}
                                </List>
                            )}
                        </Grid>
                    </Grid>
                </Box> */}
                <Box className="checkpoint-box" mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={4}>
                            <strong>Request Ref. Number</strong>
                            <h4>{assetDisposals?.request_ref_no || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Raiser Name</strong>
                            <h4>{assetDisposals?.raiser_name || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Raiser Department</strong>
                            <h4>{assetDisposals?.raiser_dept || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <strong>Disposal Type</strong>
                            <h4>{assetDisposals?.disposal_type || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Disposal Date</strong>
                            <h4>{convertUTCtoIST(assetDisposals?.raiser_date) || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <strong>Status</strong>
                            <h4>{assetDisposals?.status || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <strong>Division</strong>
                            <h4>{assetDisposals?.division || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            <strong>BC No</strong>
                            <h4>{assetDisposals?.bc_no || "N/A"}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={2}>
                        <Grid item xs={6} sm={3}>
                            <strong>Tech Specification</strong>
                            <h4>{assetDisposals?.tech_details || "N/A"}</h4>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <strong>Additional Details</strong>
                            <h4>{assetDisposals?.additional_details || "N/A"}</h4>
                        </Grid>
                    </Grid>
                    <Box mt={2}>
                        <strong>Attached Files</strong>
                        <Grid container spacing={2}>
                            {assetDisposals?.attached_files?.length > 0 ? (
                                assetDisposals.attached_files.map((file, index) => {
                                    const safeUrl = getSafeHttpUrl(file.url);
                                    return (
                                        <Grid item xs={6} sm={4} key={index}>
                                            {safeUrl ? (
                                                <a
                                                    href={safeUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: 'none', color: 'blue' }}
                                                >
                                                    {file.file_name}
                                                </a>
                                            ) : (
                                                <span>{file.file_name}</span>
                                            )}
                                            <p>{file.description}</p>
                                        </Grid>
                                    );
                                })
                            ) : (
                                <Grid item xs={12}>
                                    <p>No attached files</p>
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                </Box>


                {/*  Asset-details 2 ui option */}
                {/* <Box className="checkpoint-box" mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Asset Details
                    </Typography>
                    {assetDisposals?.asset_details?.length > 0 ? (
                        <List>
                            {assetDisposals.asset_details.map((asset, index) => (
                                <Box key={index} sx={{ overflowX: 'auto', whiteSpace: 'nowrap', padding: '1rem' }}>
                                    <ListItem>
                                        <ListItemText
                                            primary={`${asset.asset_no} | ${asset.description}`}
                                            secondary={
                                                <Box sx={{ display: 'inline-flex', minWidth: '1000px' }}>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Condition:</strong> {asset.present_condition["Condition of the Asset"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Vendor:</strong> {asset.other_details["Name of Vendor"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>PO No:</strong> {asset.other_details["PO No"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Location:</strong> {asset.other_details["Present Location"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Year of Purchase:</strong> {asset.other_details["Year of Purchase/Installation"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Weight:</strong> {asset.other_details["Weight of Asset(in kg)"] || "N/A"} kg
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Size:</strong> {asset.other_details["Overall Size of Asset(H x W x L)"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Original Value:</strong> {asset.other_details["Original asset value"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '2rem' }}>
                                                        <strong>Present Value:</strong> {asset.other_details["Present written down value"] || "N/A"}
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    </ListItem>
                                    {index < assetDisposals.asset_details.length - 1 && <Divider />}
                                </Box>
                            ))}
                        </List>
                    ) : (
                        <Typography>No asset details available</Typography>
                    )}
                </Box> */}
                <Box className="checkpoint-box" mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Asset Details
                    </Typography>
                    {assetDisposals?.asset_details?.length > 0 ? (
                        <List>
                            {assetDisposals.asset_details.map((asset, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        padding: '1rem',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    <ListItem>
                                        <ListItemText
                                            primary={
                                                <Box sx={{ display: 'inline-flex', alignItems: 'center', minWidth: '1500px' }}>

                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Asset No:</strong> {(asset.asset_no).slice(3) || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Description:</strong> {asset.description || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Asset Type:</strong> {asset.other_details["Asset Type"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Vendor:</strong> {asset.other_details["Name of Vendor"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Vendor Code:</strong> {asset.other_details["Vendor Code"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>PO No:</strong> {asset.other_details["PO No"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>PO Line Item No:</strong> {asset.other_details["PO Line Item No"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>PO Line Item Description:</strong> {asset.other_details["PO Line Item Description"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Location:</strong> {asset.other_details["Present Location"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Country of Origin:</strong> {asset.other_details["Country of Origin"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Year of Purchase:</strong> {asset.other_details["Year of Purchase/Installation"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Manufacturer Serial Number:</strong> {asset.other_details["Manufacturer Serial Number"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Model/ Project of Asset:</strong> {asset.other_details["Model/ Project of Asset"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Quantity:</strong> {asset.other_details["Quantity"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Name of Manufacturer:</strong> {asset.other_details["Name of Manufacturer"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Weight:</strong> {asset.other_details["Weight of Asset(in kg)"] || "N/A"} kg
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Size:</strong> {asset.other_details["Overall Size of Asset(H x W x L)"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Original Value:</strong> {asset.other_details["Original asset value"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Number of Loose Parts/Aggregates:</strong> {asset.other_details["Number of Loose Parts/Aggregates"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Present Value:</strong> {asset.other_details["Present written down value"] || "N/A"}
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    </ListItem>
                                    {index < assetDisposals.asset_details.length - 1 && <Divider />}
                                </Box>
                            ))}
                        </List>
                    ) : (
                        <Typography>No asset details available</Typography>
                    )}
                </Box>

                {/* Table view ui option */}
                {/* <Box className="checkpoint-box" mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Asset Details
                    </Typography>
                    {assetDisposals?.asset_details?.length > 0 ? (
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 1500 }} aria-label="asset details table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Asset No</strong></TableCell>
                                        <TableCell><strong>Description</strong></TableCell>
                                        <TableCell><strong>Condition</strong></TableCell>
                                        <TableCell><strong>Vendor</strong></TableCell>
                                        <TableCell><strong>PO No</strong></TableCell>
                                        <TableCell><strong>Location</strong></TableCell>
                                        <TableCell><strong>Year of Purchase</strong></TableCell>
                                        <TableCell><strong>Weight (kg)</strong></TableCell>
                                        <TableCell><strong>Size (H x W x L)</strong></TableCell>
                                        <TableCell><strong>Original Value</strong></TableCell>
                                        <TableCell><strong>Present Value</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {assetDisposals.asset_details.map((asset, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{asset.asset_no || "N/A"}</TableCell>
                                            <TableCell>{asset.description || "N/A"}</TableCell>
                                            <TableCell>{asset.present_condition["Condition of the Asset"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Name of Vendor"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["PO No"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Present Location"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Year of Purchase/Installation"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Weight of Asset(in kg)"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Overall Size of Asset(H x W x L)"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Original asset value"] || "N/A"}</TableCell>
                                            <TableCell>{asset.other_details["Present written down value"] || "N/A"}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <Typography>No asset details available</Typography>
                    )}
                </Box> */}


                {/* present condition 2 ui option */}
                {/* <Box className="checkpoint-box" mb={2}>
                    <Typography variant="h6" gutterBottom>
                        Present Condition of Asset
                    </Typography>
                    {assetDisposals?.asset_details?.length > 0 ? (
                        <List>
                            {assetDisposals.asset_details.map((asset, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        overflowX: 'auto',
                                        whiteSpace: 'nowrap',
                                        padding: '1rem',
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        marginBottom: '1rem',
                                    }}
                                >
                                    <ListItem>
                                        <ListItemText
                                            primary={
                                                <Box sx={{ display: 'inline-flex', alignItems: 'center', minWidth: '1000px' }}>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Asset No:</strong> {asset.asset_no || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Description:</strong> {asset.description || "N/A"}
                                                    </Box>

                                            
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Condition:</strong> {asset.present_condition["Condition of the Asset"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Parts Missing:</strong> {asset.present_condition["Are any parts missing"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Defects:</strong> {asset.present_condition["Major defects in the Asset"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Performance Achieved:</strong> {asset.present_condition["Performance achieved by the Asset"] || "N/A"}
                                                    </Box>
                                                    <Box sx={{ marginRight: '3rem' }}>
                                                        <strong>Expected Performance:</strong> {asset.present_condition["Performance expected to be achieved by the Asset"] || "N/A"}
                                                    </Box>
                                                </Box>
                                            }
                                        />
                                    </ListItem>
                                    {index < assetDisposals.asset_details.length - 1 && <Divider />}
                                </Box>
                            ))}
                        </List>
                    ) : (
                        <Typography>No asset details available</Typography>
                    )}
                </Box> */}

                {/* IDT Component */}
                <Box className="checkpoint-box" mb={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h6" gutterBottom>
                            IDT Comments
                        </Typography>
                        {/* <Typography variant="h6" gutterBottom style={{ backgroundColor: 'green', color: 'white', padding: '4px 8px', borderRadius: '4px' }}
                        >
                            Approved
                        </Typography> */}
                        <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                                backgroundColor:
                                    idtStatus === "Approved"
                                        ? 'green'
                                        : idtStatus === "Rejected"
                                            ? 'red'
                                            : idtStatus === "Not Done"
                                                ? 'gray'
                                                : 'transparent', // Default color if none matches
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                            }}
                        >
                            {idtStatus}
                        </Typography>
                    </Box>
                    <AssetTable headers={header} Width="2000" rowsData={header2Data} onRowsChange={handleIDTRowChange} />
                    <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={12}>
                                <Typography variant="h6" gutterBottom>
                                    Attachments
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <input type="file" hidden id="IDTfileInput" onChange={handleIDTFileChange} />
                                <label htmlFor="IDTfileInput">
                                    <Button variant="contained" component="span" color="primary">
                                        Select File
                                    </Button>
                                </label>
                                {IDTFile.filename && (
                                    <Typography variant="body1">Selected file: {IDTFile.filename}</Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                {/* Import Comments */}
                <Box className="checkpoint-box" mb={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h6" gutterBottom>
                            Import & Collabration Cell Comments
                        </Typography>
                        <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                                backgroundColor:
                                    importStatus === "Approved"
                                        ? 'green'
                                        : importStatus === "Rejected"
                                            ? 'red'
                                            : importStatus === "Not Done"
                                                ? 'gray'
                                                : 'transparent', // Default color if none matches
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                            }}
                        >
                            {importStatus}
                        </Typography>
                    </Box>

                    <AssetTable headers={header2} Width="2000" rowsData={header2Data} onRowsChange={handleImportRowChange} />
                    {/* <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={12}>
                                <Typography variant="h6" gutterBottom>
                                    Additional Remark
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Additional Remark"
                                    name="add-details"
                                    variant="outlined"
                                    value={ImportRemark}
                                    onChange={(e) => setImportRemark(e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={4}
                                />
                            </Grid>
                        </Grid>
                    </Box> */}
                    <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={12}>
                                <Typography variant="h6" gutterBottom>
                                    Attachments
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <input type="file" hidden id="fileInput" onChange={handleImportFile} />
                                <label htmlFor="fileInput">
                                    <Button variant="contained" component="span" color="primary">
                                        Select File
                                    </Button>
                                </label>
                                {ImportFile.filename && (
                                    <Typography variant="body1">Selected file: {ImportFile.filename}</Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                {/* Final Submission */}
                <Box className="checkpoint-box" mb={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                        <Typography variant="h6" gutterBottom>
                            Final SCM Submission
                        </Typography>
                        <Typography
                            variant="h6"
                            gutterBottom
                            style={{
                                backgroundColor:
                                    SCMStatus === "Approved"
                                        ? 'green'
                                        : SCMStatus === "Rejected"
                                            ? 'red'
                                            : SCMStatus === "Not Done"
                                                ? 'gray'
                                                : 'transparent', // Default color if none matches
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                            }}
                        >
                            {SCMStatus}
                        </Typography>
                    </Box>

                    <AssetTable headers={header3} Width="2000" rowsData={header2Data} onRowsChange={handleFinalSubmissionChange} finalSub={SCMStatus === "Approved" ? false : true} log_id={disposal_id} />
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={3} className="checkpoint-header" alignItems="center" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                        {/* <Grid item xs={2}>
                            <h3>Level Seq.</h3>
                        </Grid> */}
                        <Grid item xs={4} sm={2}>
                            <h3>Level Name</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Department</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>User Name</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Comment</h3>
                        </Grid>
                        <Grid item xs={4} sm={2}>
                            <h3>Action</h3>
                        </Grid>
                    </Grid>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <Box style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                        {assetDisposals && assetDisposals.doa.map((item, index) => {
                            const isUserAllowed = item.allowthisuser === true;

                            return (
                                <React.Fragment key={index}>
                                    <Grid
                                        container
                                        spacing={2}
                                        alignItems="center"
                                        style={{ minWidth: '600px' }} // Set minimum width for horizontal scrolling
                                    >
                                        {/* <Grid item xs={2}>
                                        {item.level_sequence}
                                    </Grid> */}
                                        <Grid item xs={2}>
                                            {item.levelname}
                                        </Grid>
                                        <Grid item xs={2}>
                                            {item.department}
                                        </Grid>
                                        <Grid item xs={2}>
                                            {item.user_name}
                                        </Grid>
                                        <Grid item xs={2}>
                                            <TextField
                                                fullWidth
                                                placeholder="Enter Comment"
                                                variant="outlined"
                                                size="small"
                                                value={reviewComments[index] || ''}
                                                onChange={(e) => handleReviewCommentChange(index, e.target.value)}
                                                disabled={!isUserAllowed} // Disable if user is not allowed
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleAction(index, item, "Approved")}
                                                        disabled={!isUserAllowed || loadingStates[index]}
                                                    >
                                                        {loadingStates[index] ? "Approving..." : "Approve"}
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() => handleAction(index, item, "Rejected")}
                                                        disabled={!isUserAllowed || loadingStates[index]}
                                                    >
                                                        {loadingStates[index] ? "Rejecting..." : "Reject"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                    </Grid>
                                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                </React.Fragment>
                            );
                        })}
                    </Box>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default AssetDisposalDetail;
